import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { Select } from 'primeng/select';
import { Nillable } from '@web/utils';
import { SelectItem } from '../../../select-item/models/select-item';

@Component({
  selector: 'app-table-filter-select',
  imports: [ReactiveFormsModule, Select],
  templateUrl: './table-filter-select.component.html',
  styleUrls: ['./table-filter-select.component.scss'],
})
export class TableFilterSelectComponent<Dictionary>
  implements OnInit, OnDestroy
{
  private readonly builder = inject(FormBuilder);

  @Input() public selectItems!: SelectItem<Dictionary>[];

  @Output() public readonly changes = new EventEmitter<Nillable<Dictionary>>();

  public control!: FormControl<Nillable<Dictionary>>;

  private readonly destroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.configureControl();
    this.configureValueChangesSource();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  private configureControl(): void {
    this.control = this.builder.control(null);
  }

  private configureValueChangesSource(): void {
    this.control.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => this.changes.emit(value));
  }
}
